import React, { useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import style from './style';
import { Autocomplete, Button, TextField } from '@mui/material';
import TextfieldAtom from '../../component/Textfield/index.jsx';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box } from '@material-ui/core';
import ButtonAtom from '../ButtonAtom';
import { Block } from '@material-ui/icons';


const Dropdown = (props) => {

  let options = [];
  const products = [...props.products];
  const productsName = props.productName;
  let initialVal;

  // console.log(props.productName);
  if (productsName)
    // initialVal = { label: props.productName, value: props.productName };
    initialVal = props.productName;

  const [value, setValue] = React.useState(initialVal);
  const [openDialog, setOpenDialog] = React.useState(false);

  if (products) {

    products.map(val => {
      options.push({
        label: val.Cname,
        value: val.Cname
      })
    })
    console.log(options);
  }



  const classes = style();

  return (
    <>
      <div>
        <FormControl className={classes.formControl}>
          <div style={{ display: "grid", gridTemplateColumns: "80% 21%" }}>
            <TextfieldAtom value={value} placeholder="chana" onChange={(e) => { setValue(e.target.value) }} />
            <Button style={{ background: "#f6f6f6", color: "#53252f", left: "-5%" }}><KeyboardArrowDownIcon onClick={() => setOpenDialog(!openDialog)} /></Button>
          </div>

        </FormControl>

      </div>
      {
        openDialog ?
          <div style={{ margin: "auto", maxWidth: 540}}>
            <div onClick={() => setOpenDialog(!openDialog)} scrollBehavior="no" style={{ width: "100%", height: "120%", position: "fixed", overflow: "hidden", top: 0, left: 0, zIndex: 99999, background: "rgba(0,0,0,0.5)", scrollBehavior: "unset" }}>

            </div>
            <Box style={{ background: "#fff", height: "80%", overflowY: "scroll", width: "80%", maxWidth: 480, zIndex: 9999999, textAlign: "center", borderRadius: "5px", position: "absolute", top: 0, padding: 5, top: "50%", right: "50%", transform: "translate(50%,-50%)" }}>

              {options && options.map((op, index) => (
                <div style={{ display: "block", padding: 10 }}>
                  <ButtonAtom name={op.label} onClick={() => { setValue(op.label); props.selectedProduct(op.label); setOpenDialog(!openDialog) }} />
                  {/* <Button>{op.label}</Button> */}
                </div>
              ))}

            </Box>
          </div>

          :
          <></>
      }


    </>

  );
};


export default Dropdown;